module.exports = __webpack_public_path__ + "img/vendor-manage.541067bc.png";